// import { ERROR_TYPE } from 'npx ';
// import { errorComparator } from 'tslint/lib/verify/lintError';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { ErrorTypes } from '../models/enums';
// Maintain consistent lodash-es syntax.
const _ = { isNil };

@Injectable()
export class ExceptionService {

  /**
   * Subject to note route has changed.
   *
   * @type {BehaviorSubject<string>}
   * @memberof ExceptionService
   */
  receivedError: BehaviorSubject<object> =
    new BehaviorSubject<object>(null);

  /**
   * Updates route change via dip component.
   *
   * @param {string} route
   * @memberof ExceptionService
   * @returns {void}
   */
  updateReceivedError(error: object) {
    this.receivedError.next(error);
  }

  /**
   * Gets the error type from the message.
   *
   * @param {string} message The message.
   * @memberof ExceptionService
   * @returns {void}
   */
  getErrorType(message: string) {
    const msg = _.isNil(message) ? '' : message;

    if (msg === 'An error occurred.' || msg.toLowerCase().indexOf('error')) {
      return ErrorTypes.ErrorWhileSaving;
    }
    if (msg === 'Bad Request' || msg.toLowerCase().indexOf('bad')) {
      return ErrorTypes.BadRequest;
    }
    return ErrorTypes.ConnectionError;
  }

  /**
   * Redirects to error page.
   *
   * @param {ErrorTypes} errorType The error type
   * @memberof ExceptionService
   */
  redirectToErrorPage(errorType: ErrorTypes) {
    this.router.navigate(['error', errorType]);
  }

  /**
   * Component tells service it received an error.
   *
   * @param {object} error The error.
   * @memberof ExceptionService
   **/
  haveReceivedError(error: object) {

    // Get the contents of the error.
    const errorContents = error['error'];

    // Get the message from the contents.
    const errorMessage = errorContents['Error'];

    // Now we need to check the type of the error.
    const errorType = this.getErrorType(errorMessage);

    // Redirect to page with error.
    this.redirectToErrorPage(errorType);
  }

  /**
   * Creates an instance of ExceptionService.
   * @param {Router} router
   * @memberof ExceptionService
   */
  constructor(private router: Router) { }

}
